import React from "react";
import IdeaList from "../../Components/IdeaList";

const Ideas = () => {
  return <IdeaList roleLabel="Ideas" />;
};

export default Ideas;
